module.exports = __webpack_public_path__ + "static/media/birthday.4d068070.svg";